import { BlockNoteEditor } from '@blocknote/core';
import { TextBlockSchema } from '../schema';
import getLinkMarkRange from './get-link-mark-range';

export default function setLinkHrefAtSelection(
  editor: BlockNoteEditor<TextBlockSchema>,
  href: string,
) {
  editor.exec((state, dispatch) => {
    if (!dispatch) {
      return false;
    }
    const linkType = state.schema.marks['link'];
    if (!linkType) {
      return false;
    }
    const { $from } = state.selection;
    const range = getLinkMarkRange($from, linkType);
    if (!range) {
      return false;
    }

    let existingAttrs: Record<string, unknown> = {};
    state.doc.nodesBetween(range.from, range.to, (node) => {
      if (node.isText) {
        const linkMark = node.marks.find((m) => m.type === linkType);
        if (linkMark) {
          existingAttrs = { ...linkMark.attrs };
          return false;
        }
      }
      return true;
    });

    const tr = state.tr;
    tr.removeMark(range.from, range.to, linkType);
    tr.addMark(
      range.from,
      range.to,
      linkType.create({ ...existingAttrs, href }),
    );
    dispatch(tr);
    return true;
  });
  editor.focus();
}
